import { CSSObject } from '@emotion/react'
import { fontSizes, fontWeights } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

const baseStyles: CSSObject = {
  zIndex: 1,
  height: '70px',
  width: '375px',
  boxSizing: 'border-box',
  padding: '0 8px',
  background:
    'linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 100%)',
}

const accountContainerStyles: CSSObject = {
  display: 'inline-flex',
  alignItems: 'center',
}

const iconContainerStyles: CSSObject = {
  ...accountContainerStyles,
}

const indicatorContainerStyles: CSSObject = {
  display: 'flex',
  height: '4px',
  listStyle: 'none',
  margin: 0,
  padding: '8px 0 8px 0',
  width: '100%',
}

const accountNameWrapperStyles: CSSObject = {
  marginLeft: '8px',
  fontSize: fontSizes.medium,
  color: colors.white.base,
  maxWidth: '240px',
  whiteSpace: 'nowrap',
}

const standardAccountStyles: CSSObject = {
  display: 'inline-flex',
  position: 'absolute',
  top: '10px',
}

const collabAccountStyles: CSSObject = {
  ...standardAccountStyles,
  columnGap: '4px',
  left: '32px',
  maxWidth: '240px',
}

const accountNameStyles: CSSObject = {
  marginLeft: '12px',
  fontWeight: fontWeights.bolder,
}

const accountCollabNameStyles: CSSObject = {
  ...accountNameStyles,
  marginLeft: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}

const infoContainerStyles: CSSObject = {
  display: 'inline-flex',
  width: '100%',
  justifyContent: 'space-between',
  position: 'relative',
}

const closeIconStyles: CSSObject = {
  marginRight: '4px',
  color: colors.white.base,
}

const moreIconStyles: CSSObject = {
  color: colors.white.base,
  marginRight: '22px',
}

const getIndicatorStyles = (isActive: boolean): CSSObject => ({
  backgroundColor: isActive ? colors.white.base : 'rgba(255, 255, 255, 0.5)',
  flex: 1,
  margin: '1px 1px',
  borderRadius: '1px',
})

const sponsoredText: CSSObject = {
  bottom: '-4px',
  color: 'white',
  fontSize: fontSizes.xSmall,
  left: '44px',
  position: 'absolute',
}

const sponsoredMiddot: CSSObject = {
  fontSize: '30px',
  margin: '0 4px 2px 4px',
}

const sponsoredPlayIcon: CSSObject = {
  margin: '0 2px 2px 0',
}

export const styles = {
  accountCollabNameStyles,
  accountContainerStyles,
  accountNameStyles,
  accountNameWrapperStyles,
  baseStyles,
  closeIconStyles,
  collabAccountStyles,
  getIndicatorStyles,
  iconContainerStyles,
  indicatorContainerStyles,
  infoContainerStyles,
  moreIconStyles,
  sponsoredMiddot,
  sponsoredPlayIcon,
  sponsoredText,
  standardAccountStyles,
}
